<template>
  <div class="hero-block">
    <div class="container">
      <h1 class="hero-block__header">
        Get expert advice on business connectivity
      </h1>
      <h2 class="hero-block__subheader">
        Get your business broadband and landlines sorted
      </h2>
      <div class="hero-block__postcode">
        <BasicPostcodeInput
          v-model="enteredPostcode"
          :is-homepage="true"
          :icon="whitelabelIcon"
          :icon-hover="whitelabelIconHover"
          name="Postcode"
          label
          placeholder="Enter your postcode"
          @submit="submitPostcode"
        />
      </div>
      <div ref="postcode-breakpoint" />
    </div>
  </div>
</template>

<script>
import BasicPostcodeInput from '@mic/frontend/inputs/BasicPostcodeInput'
import IsInViewport from '@mic/frontend/mixins/IsInViewport'

const whitelabel = require('../../../whitelabel.config')

export default {
  name: 'HeroBlock',

  components: {
    BasicPostcodeInput
  },

  mixins: [IsInViewport],

  props: {
    postcode: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      enteredPostcode: '',
      showingFixedPostcode: false,
      whitelabelIcon: whitelabel[process.env.VUE_APP_BRAND].searchButtonIcon,
      whitelabelIconHover: whitelabel[process.env.VUE_APP_BRAND].searchButtonIconHover
    }
  },

  mounted () {
    this.enteredPostcode = this.postcode
    window.addEventListener('scroll', this.toggleFixedPostcode)
  },

  beforeDestroy () {
    window.removeEventListener('scroll', this.toggleFixedPostcode)
  },

  methods: {
    toggleFixedPostcode () {
      const elem = this.$refs['postcode-breakpoint']
      this.$emit('toggleFixedPostcode', !this.isInViewport(elem))
    },
    submitPostcode (postcode) {
      this.enteredPostcode = postcode
      this.$emit('submit', this.enteredPostcode)
    }
  }
}
</script>

<style lang="scss" scoped>
.hero-block {
  padding: $spacing-80 $spacing-0;
  background-color: $home-header-bg;
  display: flex;
  align-items: center;
  min-height: 60vh;

  &__header {
    margin-bottom: $spacing-24;
    font-size: 82px;
    font-weight: bold;
  }

  &__subheader {
    margin-bottom: $spacing-48;
    font-size: 28px;
    font-weight: normal;
    text-align: center;
  }

  &__postcode {
    display: flex;
    justify-content: center;
  }

  @media (max-width: $screen-md) {
    padding: $spacing-28 $spacing-0;

    &__header {
      font-size: 37px;
      line-height: 41px;
    }

    &__subheader {
      margin-bottom: $spacing-20;
      font-size: 18px;
      line-height: 22px;
    }
  }
}
</style>
